const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateReview(form) {
  const errors = {};
  if (!form.rating) errors.rating = "Please select a star rating.";
  if (form.name.trim().length < 2) errors.name = "Please enter your name.";
  if (!EMAIL_RE.test(form.email.trim())) errors.email = "Please enter a valid email.";
  if (form.body.trim().length < 10) errors.body = "Tell us a little more — at least 10 characters.";
  return errors;
}
